// import "react-toastify/dist/ReactToastify.css";
import { Card, Container } from "reactstrap";
import { useParams } from "react-router-dom";
import "./MarketingCampaign.scss";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import BreadCrumb from "Components/Common/BreadCrumb";
import yellowShadow from "../../assets/images/YellowShadow.png";
import AddProductModal from "./Components/AddProductModal";
import ExelUplaodIcon from "../../assets/images/ExcelUpload.png";
import ExelDownloadIcon from "../../assets/images/ExelDownload.png";
import attheRate from "../../assets/images/AtTheRateIcon.png";
import DownIcon from "../../assets/images/Cell Tab (1) copy.png";
import edit from "../../assets/images/editWithRadius.png";
import trash from "../../assets/images/deleteWithRadius.png";
import tick from "../../assets/images/TickWithRadius.png";
import searchIcon from "../../assets/images/search-normal.png";
import cancel from "../../assets/images/CancelWithRadius.png";
import info from "../../assets/images/greyWarning.png";
import { motion } from "framer-motion";
import "./SelectedComponent.scss";
// import { toast, ToastContainer } from "react-toastify";
import WithDrawModal from "./Components/WithDrawModal";
import ErrorModal from "Components/Common/ErrorModal";
import Select from "react-select";
import {
  campaignPriceThunk,
  campaignWithdrawnThunk,
} from "live-slices/Marketing-Campaign/thunk";
import { useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { uploadProductInfo } from "helpers/backend_helper";
import index from "pages/Email/EmailTemplates/BasicAction";

const CampaignRegister = (props: any) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [campaignData, setCampaignData] = useState<any>();
  const [showExel, setshowExel] = useState(false);
  const [pendingSubmission, setPendingSubmission] = useState(false);
  const [withDrawModal, setWithDrawModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [campainPrice, setCampainPrice] = useState("");
  const [editingProductId, setEditingProductId] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedType, setSelectedType] = useState("productName");
  const [errorMessage, setErrorMessage] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isNewLoading, setNewIsLoading] = useState<boolean>(false);
  const [productData, setProductData] = useState<any>();
  const [activeTab, setActiveTab] = useState("Pending Submission");
  const [categoriesOptionDv, setCategoryOptions] = useState<any[]>([]);
  const [categoryId, setCategoryId] = useState<string | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedCampaignId, setSelectedCampaignId] = useState<any>();
  const [statuses, setStatuses] = useState([
    { label: "ALL SKU", value: "all", count: 0 },
    { label: "Pending Review SKUs", value: "pending", count: 0 },
    { label: "Approved SKUs", value: "approve", count: 0 },
    { label: "Rejected SKUs", value: "reject", count: 0 },
    { label: "Withdrawn SKUs", value: "withdrawn", count: 0 },
  ]);
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  const getCampaignDetailById = async () => {
    try {
      setIsLoading(true);
      const response: any = await axios.get(
        `/api/v1/marketing-campaign/byId?id=${id}`
      );
      if (response.data && response.isSuccess) {
        setIsLoading(false);
        setCampaignData(response.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleshowEditBtn = () => {
    if (isWithinDealHuntingTime()) {
      setshowExel((prev) => !prev);
    } else {
      setErrorMessage("You can only add products during the deal hunting period.");
      setShowModal({ isVisible: true, color: false });
      setTimeout(() => {
        setShowModal({ isVisible: false, color: false });
      }, 1000);
      return;
    }
  };

  const formatDate = (dateString: any) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
      .format(date)
      .replace(",", "");
  };

  const isWithinDealHuntingTime = () => {
    const now = new Date();
    const startRaw = new Date(campaignData?.timeline?.dealHuntingStartTime);
    const endRaw = new Date(campaignData?.timeline?.dealHuntingEndTime);
    const start = new Date(startRaw.getFullYear(), startRaw.getMonth(), startRaw.getDate(), 0, 0, 0);
    const end = new Date(endRaw.getFullYear(), endRaw.getMonth(), endRaw.getDate(), 23, 59, 59);
    return now >= start && now <= end;
  };


  const handleClick = () => {
    if (isWithinDealHuntingTime()) {
      setPendingSubmission(true);
    } else {
      setErrorMessage("You can only add products during the deal hunting period.");
      setShowModal({ isVisible: true, color: false });
      setTimeout(() => {
        setShowModal({ isVisible: false, color: false });
      }, 1000);
      return;
    }
  };

  const handleWithdraw = async (reason: string) => {
  if (!selectedProduct) {
    alert("Please select a reason!");
    return;
  }
  try {
    await (dispatch as any)(
      campaignWithdrawnThunk({
        subProductId: selectedProduct._id,
        campaignId: id,
        reason: reason,
      })
    );
    await new Promise((resolve) => setTimeout(resolve, 300));
    await getProductDataById(1);
    setWithDrawModal(false);
  } catch (error) {
    console.error("Withdrawal failed:", error);
  }
};

  const handlePriceChange = (productId: string, value: string) => {
    setCampainPrice((prev: any) => ({
      ...prev,
      [productId]: value,
    }));
  };

  const handleTypeChange = (e: any) => {
    setSelectedType(e);
  };

  const [currentPage, setCurrentPage] = useState<number>(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalCount, setTotalCount] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(1);
  const itemsPerPage = 10;

  const getProductDataById = async (page: number) => {
    try {
      setNewIsLoading(true);

      const queryParams: Record<any, any> = {
        page,
        count: itemsPerPage,
        campaignId: id,
      };
      if (searchTerm) queryParams.keyword = searchTerm;
      if (selectedStatus) queryParams.status = selectedStatus;
      if (categoryId) queryParams.categoryId = categoryId;
      if (selectedType) queryParams.keywordType = selectedType;

      const queryString = new URLSearchParams(queryParams as any).toString();
      const response: any = await axios.get(
        `/api/v1/marketing-campaign/product?${queryString}`
      );

      if (response.data && response.isSuccess) {
        setProductData(response.data.data);
        const productCounts = response.data.counts;
        const updatedStatuses = bindCountsToStatuses(productCounts);
        setStatuses(updatedStatuses);
        setTotalCount(response.data.counts.allCounts || 0);
        const calculatedPages =
          Math.ceil(response.data.counts.allCounts / itemsPerPage) || 1;
        setTotalPages(calculatedPages);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setNewIsLoading(false);
    }
  };

  const bindCountsToStatuses = (counts: Record<string, number>) => {
    const mapping: Record<string, string> = {
      all: "allCounts",
      pending: "pending",
      approve: "approve",
      reject: "reject",
      withdrawn: "withdrawn",
    };

    const updatedStatuses = statuses.map((status) => ({
      ...status,
      count: counts[mapping[status.value]] || 0,
    }));

    return updatedStatuses;
  };

  useEffect(() => {
    if (id) {
      getCampaignDetailById();
      getCategories();
      getProductDataById(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => { }, [statuses]);

  const getCategories = async () => {
    try {
      const response: any = await axios.get(
        `/api/v1/category/list?page=1&count=1000`
      );
      if (response.data && response.isSuccess) {
        const categoryOptions = response.data.data.map((category: any) => ({
          value: category._id,
          label: category.name,
        }));
        setCategoryOptions(categoryOptions);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [allProductData, setAllProductData] = useState<any>([]);

  const getAllProducts = async () => {
    try {
      const response: any = await axios.get(
        `/api/v1/marketing-campaign/product/seller?page=1&count=10000&status=active`
      );
      if (response.data && response.isSuccess) {
        setAllProductData(response.data.data);
      }
    } catch (error) { }
  };

  const handleDownload = async () => {
    try {
      const subProductIds = allProductData.map((product: any) => ({
        "SubProduct Id": product._id,
      }));
      const worksheet = XLSX.utils.json_to_sheet(subProductIds);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "SubProducts");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(file, "Products.xlsx");
    } catch (error) { }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData: any = new FormData();
      formData.append("file", file, "SubProducts.xlsx");
      const response: any = await uploadProductInfo(formData);
      if (response.data && response.isSuccess) {
        setshowExel((prev) => !prev);
        setCurrentPage(1);
        setProductData([]);
        await getProductDataById(1);
        setActiveTab("Registered Product");
        setErrorMessage("Product Added Successfully");
        setShowModal({ isVisible: true, color: true });
        setTimeout(() => {
          setShowModal({ isVisible: false, color: true });
        }, 1000);
      }
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  useEffect(() => { }, [allProductData]);

  useEffect(() => {
    getProductDataById(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, selectedType, categoryId, currentPage, selectedStatus]);

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <WithDrawModal
        show={withDrawModal}
        onCloseClick={() => {
          setWithDrawModal(false);
          getProductDataById(1);
        }}
        onWithdraw={handleWithdraw}
        product={selectedProduct}
      />
      {/* <ToastContainer closeButton={false} /> */}
      <AddProductModal
        show={pendingSubmission}
        productCampaign={productData}
        onCloseClick={() => {
          setPendingSubmission(false);
          setActiveTab("Registered Product");
          getProductDataById(1);
        }}
      />
      <div className="page-content CampaignRegisterMainPage">
        <Container fluid>
          <BreadCrumb
            title="Campaign Performance"
            pageTitle="Promotion"
            pageTitleRoute="/promotion"
          />
          {isLoading ? (
            <div className="loaderNewDv centralizeTwo"></div>
          ) : (
            <>
              {campaignData ? (
                <>
                  <Card className="CampaignRegisterMainCard">
                    <div className="headRegister">
                      <div className="d-flex align-items-center gap-2">
                        <p>{campaignData.status}</p>
                        <h1>{campaignData.name}</h1>
                      </div>
                      <div className="d-flex align-items-end justify-content-between">
                        <div>
                          <h6>Live Date</h6>
                          {campaignData?.timeline?.megaDurationStartTime &&
                            campaignData?.timeline?.megaDurationEndTime ? (
                            <h2>
                              {formatDate(
                                campaignData.timeline.megaDurationStartTime
                              )}{" "}
                              -{" "}
                              {formatDate(
                                campaignData.timeline.megaDurationEndTime
                              )}
                            </h2>
                          ) : null}
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <h4>View Campaign Info</h4>
                          <i className="bx bxs-chevron-down-circle text-black"></i>
                        </div>
                      </div>
                    </div>
                    <img src={yellowShadow} alt="" />
                  </Card>
                  <Card className="CampaignRegisterMainCard-two">
                    <div className="text">
                      <h1>Registration Open Now</h1>
                      <p>
                        Registration is now open! Join our flash sale starting
                        soon and secure your spot before the early registration
                        ends!
                      </p>
                      <p>
                        Campaign Live Duration{" "}
                        <span>
                          {formatDate(
                            campaignData?.timeline?.megaDurationStartTime
                          )}
                        </span>{" "}
                      </p>
                      {/* <div className="ViewMore">
                        <i className="bx bxs-chevron-down-circle text-black"></i>
                        <h4>View More</h4>
                      </div> */}
                    </div>
                  </Card>
                  <Card className="TabBarScreenMain-Card">
                    <div style={{ display: "flex", height: "26px" }}>
                      {["Pending Submission", "Registered Product"].map(
                        (tab) => (
                          <div data-testing-id={"tabButton_CampaignRegister" + index}
                            key={tab}
                            onClick={async () => {
                              if (tab === "Registered Product") {
                                setCurrentPage(1);
                                setProductData([]);
                                await getProductDataById(1);
                                setActiveTab(tab);
                              } else {
                                setActiveTab(tab);
                              }
                            }}
                            style={{
                              padding: "0px 10px",
                              cursor: "pointer",
                              borderBottom:
                                activeTab === tab
                                  ? "2px solid #3786FB"
                                  : "none",
                              fontWeight: activeTab === tab ? "600" : "400",
                              color: activeTab === tab ? "#3786FB" : "#343944",
                            }}
                          >
                            {tab}
                          </div>
                        )
                      )}
                    </div>
                    {activeTab === "Pending Submission" ? (
                      <div className="MainRegisterProduct">
                        <div className="text">
                          <h1>
                            Submit products for inclusion in the campaign.
                          </h1>
                          <p>
                            Product submissions are now open! Get your items
                            included in our upcoming <br /> campaign and ensure
                            you don't miss out on this opportunity!
                          </p>
                        </div>
                        <div className="editTab">
                          <div className="d-flex gap-2">
                            <p
                              onClick={toggleshowEditBtn}
                              className="DropDown"
                              data-testing-id="submitByExcel_AddVoucher"
                              style={{
                                cursor: isWithinDealHuntingTime()
                                  ? "pointer"
                                  : "not-allowed",
                                opacity: isWithinDealHuntingTime() ? 1 : 0.5,
                              }}
                            >
                              <img src={attheRate} alt="" />
                              Submit by Excel
                              <img src={DownIcon} alt="" />
                            </p>
                            <span
                              data-testing-id="addproductButton_AddVoucher"
                              onClick={handleClick}
                              className="blue"
                              style={{
                                cursor: isWithinDealHuntingTime()
                                  ? "pointer"
                                  : "not-allowed",
                                opacity: isWithinDealHuntingTime() ? 1 : 0.5,
                              }}
                            >
                              + Add Products
                            </span>
                          </div>

                          {showExel && (
                            <>
                              <motion.div
                                initial={{
                                  opacity: 0,
                                  y: -20,
                                  scale: 0.8,
                                  rotate: -5,
                                }}
                                animate={{
                                  opacity: 1,
                                  y: 0,
                                  scale: 1,
                                  rotate: 0,
                                }}
                                exit={{
                                  opacity: 0,
                                  y: -20,
                                  scale: 0.8,
                                  rotate: -5,
                                }}
                                transition={{
                                  type: "spring",
                                  stiffness: 200,
                                  damping: 10,
                                }}
                              >
                                <div className="diff-btn mb-2">
                                  <button
                                    className="falseDv"
                                    data-testing-id="downloadExcelButton_AddVoucher"
                                    onClick={handleDownload}
                                  >
                                    <img src={ExelDownloadIcon} alt="" />
                                    Download Excel
                                  </button>
                                  <input
                                    type="file"
                                    accept=".csv, .xls, .xlsx"
                                    ref={inputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                  />

                                  <button
                                    className="falseDv"
                                    data-testing-id="uploadExcelButton_AddVoucher"
                                    onClick={() => inputRef.current?.click()}
                                  >
                                    <img
                                      src={ExelUplaodIcon}
                                      alt="Upload Excel"
                                    />
                                    Upload Excel
                                  </button>

                                  {/* 
                                  <button
                                    className="falseDv"
                                    data-testing-id="uploadExcelButton_AddVoucher"
                                    onClick={handleUpload}
                                  >
                                    <img
                                      src={ExelUplaodIcon}
                                      alt="Upload Excel"
                                    />
                                    Upload Excel
                                  </button> */}
                                </div>
                              </motion.div>
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="MainRegisteredProduct">
                        <div className="StatusBarMain">
                          <>
                            {statuses.map((statusObj: any, index: number) => (
                              <div
                                key={index}
                                className={`status ${activeIndex === index ? "active" : ""
                                  }`}
                                onClick={() => {
                                  setActiveIndex(index);
                                  setSelectedStatus(statusObj.value);
                                }}
                                data-testing-id={
                                  "statusButton_RegisteredProduct" + index
                                }
                              >
                                <p>{statusObj.label}</p>
                                <span>{statusObj.count}</span>
                              </div>
                            ))}
                          </>
                        </div>
                        <div className="head">
                          <div tata-testing-id="categorySelect_RegisteredProduct" > 
                            <Select
                              options={categoriesOptionDv}
                              onChange={(selectedOption: any) => {
                                const id = selectedOption?.value || null;
                                setCurrentPage(1);
                                setCategoryId(id);
                              }}
                              placeholder="Please select category or search with keyword"
                              isSearchable
                              className="select-different"
                              inputId="productSelect"
                            />
                          </div>
                          <div className="searchAndSelect">
                            <select
                              name="typeSelect"
                              data-testing-id="nameSelect_RegisteredProduct"
                              onChange={(e) => {
                                setCurrentPage(1);
                                handleTypeChange(e.target.value);
                              }}
                              value={selectedType}
                            >
                              <option value="sku">Seller Sku</option>
                              <option value="productName">Product Name</option>
                              <option value="sellerName">Seller Name</option>
                              <option value="skuId">Sku Id</option>
                            </select>
                            <div className="input">
                              <input
                                type="text"
                                placeholder="Type to search"
                                data-testing-id="searchInput_RegisteredProduct"
                                value={searchTerm}
                                onChange={(e) => {
                                  setCurrentPage(1);
                                  setSearchTerm(e.target.value);
                                }}
                              />
                              <img src={searchIcon} alt="Search" data-testing-id="Search" />
                            </div>
                          </div>
                        </div>
                        <div className="ProductListing">
                          <div className="RegisteredProductListing">
                            <table className="w-100">
                              <thead>
                                <tr>
                                  <th className="top-left">
                                    <p>
                                      <span>Basic Info </span>
                                    </p>
                                  </th>
                                  <th>
                                    <p>
                                      <span>Category Name</span>
                                    </p>
                                  </th>
                                  <th>
                                    <p>
                                      <span>Status </span>
                                    </p>
                                  </th>
                                  <th>
                                    <p>
                                      <span>Current Price</span>
                                    </p>
                                  </th>
                                  <th>
                                    <p>
                                      <span>Current Stock</span>
                                    </p>
                                  </th>
                                  <th>
                                    <div className="d-flex gap-1 align-items-center">
                                      <p>
                                        <span>Campaign Price</span>
                                      </p>
                                      <img data-testing-id="infoIcon_RegisteredProduct"
                                        src={info}
                                        alt=""
                                        style={{
                                          width: "11px",
                                          height: "11px",
                                        }}
                                      />
                                    </div>
                                  </th>
                                  <th className="top-right">
                                    <p>
                                      <span >Actions</span>
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(productData) &&
                                  productData.length > 0 ? (
                                  productData.map((product: any) => (
                                    <>
                                      <tr>
                                        <td>
                                          <div className="productNewRow">
                                            <img
                                              src={product.productImage}
                                              alt=""
                                            />
                                            <div>
                                              <p>{product.nameEn}</p>
                                              <div className="d-flex gap-2 py-1">
                                                <h5>
                                                  ID{" "}
                                                  <span className="fw-bold">
                                                    {product.buypassProductId}
                                                  </span>
                                                </h5>
                                                <i
                                                  className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    navigator.clipboard.writeText(
                                                      product.buypassProductId
                                                    );
                                                    setShowModal({
                                                      isVisible: true,
                                                      color: true,
                                                    });
                                                    setErrorMessage(
                                                      "Product Id Copied!"
                                                    );
                                                    setTimeout(() => {
                                                      setShowModal({
                                                        isVisible: false,
                                                        color: false,
                                                      });
                                                    }, 1000);
                                                  }}
                                                ></i>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div className="profile d-flex align-items-center gap-2">
                                            <img
                                              src={product.productImage}
                                              alt=""
                                              width={50}
                                              height={50}
                                              data-testing-id="productImage_RegisteredProduct"
                                            />
                                            <div>
                                              <p>{product.name}</p>
                                              <div className="d-flex gap-2 py-1">
                                                <h5>
                                                  Seller SKU:{" "}
                                                  <span className="fw-bold">
                                                    {product.sku}
                                                  </span>
                                                </h5>
                                                <i
                                                  className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    navigator.clipboard.writeText(
                                                      product.sku
                                                    );
                                                    setShowModal({
                                                      isVisible: true,
                                                      color: true,
                                                    });
                                                    setErrorMessage(
                                                      "Seller Sku Copied!"
                                                    );
                                                    setTimeout(() => {
                                                      setShowModal({
                                                        isVisible: false,
                                                        color: false,
                                                      });
                                                    }, 1000);
                                                  }}
                                                ></i>
                                              </div>
                                              <div className="d-flex gap-2">
                                                <h5>
                                                  SKU ID:{" "}
                                                  <span className="fw-bold">
                                                    {product._id}
                                                  </span>
                                                </h5>
                                                <i
                                                  className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    navigator.clipboard.writeText(
                                                      product._id
                                                    );
                                                    setShowModal({
                                                      isVisible: true,
                                                      color: true,
                                                    });
                                                    setErrorMessage(
                                                      "SKU ID Copied!"
                                                    );
                                                    setTimeout(() => {
                                                      setShowModal({
                                                        isVisible: false,
                                                        color: false,
                                                      });
                                                    }, 1000);
                                                  }}
                                                ></i>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <p className="text-secondary fw-bold">
                                            {product.category?.name ??
                                              "No category"}
                                          </p>
                                        </td>
                                        <td>
                                          <div className="status">
                                            <div className="dot"></div>
                                            <p>{product.campaignStatus}</p>
                                          </div>
                                        </td>
                                        <td>
                                          <p>Rs. {product.price}</p>
                                        </td>
                                        <td>
                                          <p>{product.stock}</p>
                                        </td>
                                        <td>
                                          <div className="validation">
                                            {product.campaignStatus ===
                                              "reject" ||
                                              product.campaignStatus ===
                                              "withdrawn" ? (
                                              <span>-</span>
                                            ) : product.campaignPrice == null ||
                                              editingProductId ===
                                              product._id ? (
                                              <>
                                                <input
                                                  type="number"
                                                  data-testing-id="campaignPriceInput_RegisteredProduct"
                                                  value={
                                                    campainPrice[product._id] ??
                                                    product.campaignPrice ??
                                                    ""
                                                  }
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (Number(value) < 0) value = "0";
                                                    handlePriceChange(
                                                      product._id,
                                                      value
                                                    );
                                                  }}
                                                  placeholder="Enter campaign price"
                                                  min="0"
                                                  max={product.price}
                                                  onKeyDown={e => {
                                                    if (e.key === '-' || e.key === 'e') {
                                                      e.preventDefault();
                                                    }
                                                  }}
                                                />
                                              </>
                                            ) : (
                                              <p>{product.campaignPrice}</p>
                                            )}
                                          </div>
                                        </td>

                                        <td>
                                          {product.campaignStatus ===
                                            "reject" ||
                                            product.campaignStatus ===
                                            "withdrawn" ? (
                                            <span>-</span>
                                          ) : product.campaignPrice == null ||
                                            editingProductId === product._id ? (
                                            <div className="d-flex gap-2">
                                              <img
                                                onClick={() => {
                                                  var enteredPrice = Number(campainPrice[product._id]);
                                                  var originalPrice = Number(product.price);
                                                  var maxAllowed = originalPrice - (originalPrice * 0.10);
                                                  if (!enteredPrice || enteredPrice === 0) {
                                                    setErrorMessage("Please fill the price field.");
                                                    setShowModal({ isVisible: true, color: false });
                                                    setTimeout(() => {
                                                      setShowModal({ isVisible: false, color: false });
                                                    }, 3000);
                                                    return;
                                                  }
                                                  if (enteredPrice === originalPrice) {
                                                    setErrorMessage("Entered price cannot be same as original price.");
                                                    setShowModal({ isVisible: true, color: false });
                                                    setTimeout(() => {
                                                      setShowModal({ isVisible: false, color: false });
                                                    }, 3000);
                                                    return;
                                                  }
                                                  if (enteredPrice > maxAllowed) {
                                                    setErrorMessage(
                                                      `Entered price must be 10% less than product price.\nMaximum allowed price: Rs. ${maxAllowed}`
                                                    );
                                                    setShowModal({ isVisible: true, color: false });
                                                    setTimeout(() => {
                                                      setShowModal({ isVisible: false, color: false });
                                                    }, 3000);
                                                    return;
                                                  }
                                                  const finalCampaignId = id;
                                                  (dispatch as any)(
                                                    campaignPriceThunk({
                                                      subProductId: product._id,
                                                      campaignId: finalCampaignId,
                                                      campainPrice: enteredPrice,
                                                    })
                                                  )
                                                    .then(() => {
                                                      setEditingProductId(null);
                                                      getProductDataById(1);
                                                    })
                                                    .catch((error: any) => {
                                                    });
                                                }}
                                                src={tick}
                                                alt="Approve"
                                                data-testing-id={"approveIcon_RegisteredProduct" + product._id}
                                              />
                                              <img
                                                onClick={() => {
                                                  setSelectedProduct(product);
                                                  setWithDrawModal(true);
                                                }}
                                                src={cancel}
                                                alt="Cancel"
                                                data-testing-id={"cancelIcon_RegisteredProduct" + product._id}
                                              />
                                            </div>
                                          ) : (
                                            <div className="d-flex gap-2">
                                              <img data-testing-id={"editIcon_RegisteredProduct" + product._id}
                                                onClick={() =>
                                                  setEditingProductId(
                                                    product._id
                                                  )
                                                } // enter edit mode
                                                src={edit}
                                                alt="Edit"
                                              />
                                              <img data-testing-id={"deleteIcon_RegisteredProduct" + product._id}
                                                onClick={() => {
                                                  setSelectedProduct(product);
                                                  setWithDrawModal(true);
                                                }}
                                                src={trash}
                                                alt="Delete"
                                              />
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="paginationDv  mt-4 d-flex ">
                          <div className="paginationDv d-flex justify-content-end">
                            <nav aria-label="Page navigation">
                              <ul className="pagination detailPagepagi m-0">
                                <li
                                  className={`page-item ${currentPage === 1 ? "disabled" : ""
                                    }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() =>
                                      setCurrentPage((prev) =>
                                        Math.max(prev - 1, 1)
                                      )
                                    }
                                    style={{ height: "26px", border: "none" }}
                                  >
                                    <i
                                      className="bx bxs-left-arrow"
                                      style={{ height: "11px" }}
                                    ></i>
                                  </button>
                                </li>

                                {Array.from(
                                  { length: Math.min(totalPages, 5) },
                                  (_, i) => {
                                    const startPage = Math.max(
                                      Math.min(currentPage - 2, totalPages - 4),
                                      1
                                    );
                                    const page = startPage + i;
                                    if (page > totalPages) return null;
                                    return (
                                      <li
                                        key={page}
                                        className={`page-item ${currentPage === page ? "active" : ""
                                          }`}
                                      >
                                        <button
                                          className="page-link orderPg"
                                          onClick={() => setCurrentPage(page)}
                                          style={{ height: "26px" }}
                                        >
                                          {page}
                                        </button>
                                      </li>
                                    );
                                  }
                                )}

                                <li
                                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                    }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() =>
                                      setCurrentPage((prev) =>
                                        Math.min(prev + 1, totalPages)
                                      )
                                    }
                                    style={{ height: "26px", border: "none" }}
                                  >
                                    <i
                                      className="bx bxs-right-arrow"
                                      style={{ height: "11px" }}
                                    ></i>
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    )}
                  </Card>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default CampaignRegister;
